import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";

export const BackofficeContainer = styled.div`
  height: 800px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #010606;

  @media screen and (max-width: 768px) {
    height: 1100px;
  }

  @media screen and (max-width: 480px) {
    height: 1300px;
  }
`;
export const BackofficeWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 16px;
  padding: 0 50px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 786px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

export const BackofficeAlignmentWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  padding: 0px 50px;
  margin-left: 260px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
    margin-left: 0px;
  }

  @media screen and (max-width: 786px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
    margin-left: 0px;
  }
`;
export const BackofficeCard = styled.div`
  background: #010606;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  border: solid;
  border-color: ${(props) => props.backgroundColor};

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;
export const BackofficeIcon = styled.img`
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
`;
export const BackofficeH1 = styled.h1`
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 64px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;
export const BackofficeH2 = styled.h2`
  font-size: 2rem;
  margin-bottom: 10px;
  text-decoration: none;
  color: #fff;
`;

export const BackofficeLink = styled(LinkR)`
  font-size: 2rem;
  text-decoration: none;
  color: #fff;
`;

export const BackofficeP = styled.p`
  font-size: 1rem;
  text-align: center;
`;
